/**
 * @fileoverview Main application router component.
 */

import React from "react";
import {Redirect, BrowserRouter, Router, Switch} from "react-router-dom";
import {FRONTEND_BASE_NAME} from "../config";
import {SentryRoute as Route} from "../utils/sentryRoute";

import {AdmissionRoutes} from "./AdmissionRoutes";
import {AdminRoutes} from "./AdminRoutes";
import {ADMISSION_WELCOME_ROUTE} from "../pages/page-admission-welcome/route";

import {PagePasswordChange} from "../pages/page-password-change";
import {PagePasswordReset} from "../pages/page-password-reset";
import {PageConfirmNewUser} from "../pages/page-confirm-new-user";
import {history} from "../utils/history";
import {LEGACY_ADMISSION_PATH, toWorkflowPath} from "./legacyAdmissionPath";

/**
 * Main application router that handles all top-level routes.
 * Sets up the browser router with the frontend base name and custom history.
 *
 * @returns {JSX.Element} The main router component.
 */
export const AppRouter = () => (
  <BrowserRouter basename={FRONTEND_BASE_NAME}>
    <Router history={history}>
      <Switch>
        <Route path="/workflow" component={AdmissionRoutes} />
        <Route path="/admin" render={AdminRoutes} />
        <Route path="/request-reset-email" component={PagePasswordReset} />
        <Route path="/confirm-new-user/:token" component={PageConfirmNewUser} />
        <Route path="/confirm-password/:token" component={PagePasswordChange} />
        <Route
          path={LEGACY_ADMISSION_PATH}
          render={({location}) => (
            <Redirect
              to={{...location, pathname: toWorkflowPath(location.pathname)}}
            />
          )}
        />
        <Redirect from="/" to={ADMISSION_WELCOME_ROUTE} />
      </Switch>
    </Router>
  </BrowserRouter>
);
